import { render, staticRenderFns } from "./HyyyTypeManage.vue?vue&type=template&id=0620010e&scoped=true&"
import script from "./HyyyTypeManage.vue?vue&type=script&lang=js&"
export * from "./HyyyTypeManage.vue?vue&type=script&lang=js&"
import style0 from "./HyyyTypeManage.vue?vue&type=style&index=0&id=0620010e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0620010e",
  null
  
)

export default component.exports